module.exports = __webpack_public_path__ + "static/web_enjoy-193b3919df1c9c3a5e3e3f44cd528659.svg";